import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Loading from '@/components/loading/loading'
import moment from 'moment';

@Component({
  components: {
    Loading
  }
})
export default class CheckoutAddressSchedule extends Vue {

  @Prop({ default: false }) addAddress;
  @Prop({ default: false }) addProgram;
  @Prop({ default: false }) loading;

  @Getter getUser;
  @Getter getCurrentProgram;
  @Getter getCurrentAddress;
  @Getter getIsToken;
  @Getter getCity;
  @Getter getCurrentCityZone;

  @Getter getIsOnDemandValid;

  @Mutation PATH_TEMPORAL;
  @Mutation CURRENT_ADDRESS;
  @Mutation CURRENT_PROGRAM;
  @Mutation CURRENT_CITY_ZONE;

  currentZone = null;
  today = null;

  get getIsValidForOnDemand() {
    let response = false;
    if (
      this.getIsOnDemandValid &&
      this.getIsOnDemandValid.valid &&
      this.getIsOnDemandValid.zone &&
      this.getIsOnDemandValid.zone.on_demand &&
      this.getIsOnDemandValid.zone.range_work_day_open >= 0 &&
      this.getIsOnDemandValid.zone.range_work_day_close >= 0 &&
      this.getIsOnDemandValid.zone.deivery_time_hour >= 0
    ) {
      const topHour = moment().hour(this.getIsOnDemandValid.zone.range_work_day_close);
      const initialHour = moment().hour(this.getIsOnDemandValid.zone.range_work_day_open);
      if (
        topHour.hour() > this.today.hour() &&
        initialHour.hour() <= this.today.hour()
      ) {
        if (
          this.getCurrentCityZone &&
          this.getCurrentCityZone.delivery_schedule &&
          this.getCurrentCityZone.delivery_schedule.weekdays &&
          this.getCurrentCityZone.delivery_schedule.weekdays.length
        ) {
          const weekDay = this.today.day();
          const availableDays = this.getCurrentCityZone.delivery_schedule.weekdays;
          
          for(let i=0; i < availableDays.length && !response; i++) {
            if(weekDay === parseInt(availableDays[i])) {
              response = true;
            }
          }
        }
      }
    }
    return response;
  }

  get getOnDemandButtonLabel() {
    let response = "No disponible en tu zona";
    if(this.getIsValidForOnDemand) {
      const mins = this.getIsOnDemandValid.zone.deivery_time_hour * 60;
      response = `Aprox. ${mins} minutos`;
    }
    return response;
  }

  get getCurrentAddressToText() {
    return this.getCurrentAddress ? this.getCurrentAddress.address : "+ Agregar Dirección";
  }

  get getTypeOfProgram() {
    let response = "";
    if (
      this.getCurrentProgram &&
      this.getCurrentProgram.hourRange &&
      this.getCurrentProgram.hourRange.length
    ) {
      if(this.getCurrentProgram.hourRange === 'on_demand') {
        response = "on_demand";
      } else {
        response = "program";
      }
      
    }
    return response;
  }

  get getETA() {
    let response = "";
    const time = moment();
    time.add('hours', this.getIsOnDemandValid.zone.deivery_time_hour);
    response = time.format('hh:mm a');
    return response;
  }

  mounted() {
    if (!this.getCurrentAddress) {
      this.setDefaultUserAddress();
    }
    this.today = moment(new Date());
    this.setDefaultDay();
    this.onCurrentAddressChange();
  }

  setDefaultDay() {
    if (
      this.getCurrentProgram &&
      this.getCurrentProgram.day &&
      this.getCurrentProgram.day.length
    ) {
      const currentProgramDay = moment(this.getCurrentProgram.day);
      const compareToday = moment(new Date());

      currentProgramDay.set('hour', 0);
      currentProgramDay.set('minute', 0);
      currentProgramDay.set('second', 0);
      compareToday.set('hour', 0);
      compareToday.set('minute', 0);
      compareToday.set('second', 0);

      if(currentProgramDay.isBefore(compareToday)) {
        this.CURRENT_PROGRAM({
          day: '',
          hourRange: ''
        });
      }
    }
  }

  setDefaultUserAddress() {
    if (this.getUser && this.getUser.addresses) {
      const address = this.getUser.addresses[0];
      this.CURRENT_ADDRESS(address);
    }
  }

  @Watch('getCurrentAddress')
  onCurrentAddressChange() {
    if(this.getCurrentAddress && this.getCurrentAddress.zone_id) {
      const previousZone = this.getCurrentCityZone;
      this.currentZone = this.getCityZoneById(this.getCurrentAddress.zone_id);
      this.CURRENT_CITY_ZONE(this.currentZone);
      if(previousZone.id !== this.currentZone.id) {
        this.CURRENT_PROGRAM({
          day: '',
          hourRange: ''
        });
      }
    }
  }

  @Watch('addAddress')
  onAddAddressChange() {
    if(this.addAddress) {
      this._toggleAddressModal();
      this.$emit('onAddressAdded');
    }
  }

  @Watch('addProgram')
  onAddProgramChange() {
    if(this.addProgram) {
      this._toggleProgramModal();
      this.$emit('program-modal-open');
    }
  } 

  _toggleAddressModal() {
    if (this.getIsToken) {
      this.$root.$emit("address-modal");
    } else {
      this._redirectToLogin("address");
    }
  }

  _onSelectOnDemand() {
    this.today = null;
    this.today = moment(new Date());
    if(this.getIsValidForOnDemand && this.today) {
      const day = this.today.clone();
      day.set('hour', 0);
      day.set('minute', 0);
      day.set('second', 0);
      const program = {
        day: day,
        hourRange: "on_demand"
      };
      this.CURRENT_PROGRAM(program);
    }
  }

  _toggleProgramModal() {
    if (this.getIsToken) {
      this.$root.$emit('program-modal');
    } else {
      this._redirectToLogin('program')
    }
  }

  _redirectToLogin(option: string) {
    const name = this.$route.name;
    const query = this.$route.query;
    const params = this.$route.params;
    params["modal"] = option;

    this.PATH_TEMPORAL({ name, params, query });
    window.location.href = "/login";
  }

  private getCityZoneById(zoneId) {
    let res = null;
    if(this.getCity && this.getCity.zones) {
      for(let i=0; i < this.getCity.zones.length && !res; i++) {
        if(this.getCity.zones[i].id === zoneId) {
          res = this.getCity.zones[i];
        }
      }
    }
    return res;
  }
}
